<script lang="ts">
  import type { Object3D, Object3DEventMap } from 'three'
  import TransformBase from './TransformBase.svelte'
  import i18n from '../../../../../i18n'
  import {
    convertToSceneUnit,
    convertToUserUnit,
  } from '../../../../../helpers/scene-json'
  import { getWorldPositionAxis, setWorldPositionAxis } from '../../../../../helpers/world-position'
  import { ThreeItemKeys, ThreeItemTypes } from '../../../../../constants/three'
  import useObjectQueries from '../../../hooks/useObjectQueries'

  const { object }: { object: Object3D<Object3DEventMap> } = $props()

  const { useObject, updateUserDataMutation } = useObjectQueries()
  const data = $derived(useObject(object.uuid))

  const axes = {
    x: ThreeItemKeys.TRANSLATION_LOCKED_X,
    y: ThreeItemKeys.TRANSLATION_LOCKED_Y,
    z: ThreeItemKeys.TRANSLATION_LOCKED_Z,
  }
</script>

{#key data.dataUpdatedAt}
  {#if data.data}
    <TransformBase
      getLocked={(obj, axis) =>
        obj.userData[ThreeItemKeys.ITEM_TYPE] === ThreeItemTypes.FILE
          ? obj.userData[axes[axis]]
          : obj.parent?.userData[ThreeItemKeys.LOCKED] || obj.userData[axes[axis]]}
      getValue={(obj, axis) => convertToUserUnit(getWorldPositionAxis(obj, axis)) as number}
      object={data.data}
      setLocked={(obj, axis, value) => updateUserDataMutation.mutate({ objectUuid: object.uuid, object: { [axes[axis]]: value } })}
      setValue={(obj, axis, value) =>
        setWorldPositionAxis(obj, axis, convertToSceneUnit(value) as number)}
      title={$i18n.t('project.rightBar.position.translation')}
    />
  {/if}
{/key}
